import {
  FormHelperText,
  CheckboxProps,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';
import { InformationDialog } from '../../components/investors/components';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useState } from 'react';
import { useField } from 'formik';

export const MFCheckbox = function ({
  label,
  name,
  onChange,
  checked,
  sx,
  info,
  infoLabel,
  ...props
}: CheckboxProps & {
  label: string;
  name: string;
  info?: string;
  infoLabel?: string;
}): JSX.Element {
  const [field, meta] = useField(name);
  checked = checked || field.value;
  onChange = onChange || field.onChange;
  const [dialogMessage, setDialogMessage] = useState({ message: '', title: '' });
  const [open, setOpen] = useState(false);
  const handleOpen = ({ message, title }: { message: string; title: string }) => {
    setOpen(true), setDialogMessage({ message, title });
  };
  const handleClose = () => {
    setOpen(false);
    setDialogMessage({ message: '', title: '' });
  };
  const errorText = meta.error && meta.touched ? meta.error : '';

  return (
    <FormGroup>
      <FormControlLabel
        control={<Checkbox {...field} {...props} checked={checked} onChange={onChange} />}
        name={name}
        label={
          <>
            {label}
            {info && (
              <Typography component="span" sx={{ position: 'relative', marginLeft: 1, bottom: -5 }}>
                <InfoOutlinedIcon
                  color="info"
                  fontSize="small"
                  onClick={() => handleOpen({ message: info || '', title: infoLabel || '' })}
                />
              </Typography>
            )}
          </>
        }
        sx={{
          '& .Mui-disabled': {
            cursor: !props.disabled ? 'pointer' : 'not-allowed !important',
            pointerEvents: 'all',
          },
          ...sx,
        }}
      />
      <FormHelperText error sx={{ marginLeft: 'unset' }}>
        {errorText}
      </FormHelperText>
      <InformationDialog
        onClose={handleClose}
        open={open}
        content={dialogMessage.message}
        title={dialogMessage.title}
        infoIcon={false}
      />
    </FormGroup>
  );
};

export default MFCheckbox;
